<template>
    <AgendaManage
        :idFrom="$route.params.id != undefined ? $route.params.id : null"
        :reloadData="reloadData"
        @saved="redirectToList()"
        @voltar="$router.push({ name: 'crm-agenda-list' })"
    />
</template>

<script>
import AgendaManage from '@/components/vendas/agenda/AgendaManage.vue';

export default {
    name: 'AgendaManageRoute',

    beforeRouteUpdate(to, from, next) {
        if (from.name == 'crm-agenda-edit' && to.name == 'crm-agenda-edit') {
            this.reloadData = true;
            setTimeout(() => (this.reloadData = false), 300);
        }
        next();
    },
    components: {
        AgendaManage,
    },
    data() {
        return {
            reloadData: false,
        };
    },
    methods: {
        redirectToList() {
            setTimeout(() => this.$router.push({ name: 'crm-agenda-list' }), 1000);
        },
    },
};
</script>
